export default class Address {
	street: string;
	postalCode: string;
	city: string;
	country: string;
	notes: string;
}
